<div class="date-picker-box" style="background-color:white">
    <fa-icon [icon]="faCalendar" style="color:black; font-size: 25px;"></fa-icon>
    <input [ranges]="ranges" [alwaysShowCalendars]="true" type="text" ngxDaterangepickerMd (datesUpdated)="datesUpdated()"
        [(ngModel)]="dashService.selectedDate" class="date-picker" />
</div>